"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERNAL_EVENT_FLAG = exports.InternalTracker = exports.tracker = void 0;
var mixpanel_browser_1 = require("mixpanel-browser");
var __1 = require("..");
var INTERNAL_EVENT_FLAG = 'isKaluzaEvent';
exports.INTERNAL_EVENT_FLAG = INTERNAL_EVENT_FLAG;
var DEFAULT_TRACKER_NAME = 'kaluza-internal-events';
var defaultOptions = {};
var InternalTracker = /** @class */ (function () {
    function InternalTracker(instanceName, options) {
        if (instanceName === void 0) { instanceName = DEFAULT_TRACKER_NAME; }
        if (options === void 0) { options = defaultOptions; }
        var _this = this;
        this.instanceName = instanceName;
        this.options = options;
        this.init = function () {
            var kaluzaDiagnosticsKey = __1.configService.getConfig().kaluzaDiagnosticsKey;
            if (kaluzaDiagnosticsKey) {
                _this.instance = (0, mixpanel_browser_1.init)(kaluzaDiagnosticsKey, _this.options, _this.instanceName);
            }
        };
        this.dispatch = function (event) {
            if (_this.instance && filterEvent(event)) {
                var _a = formatEvent(event), name_1 = _a.name, data = _a.data;
                _this.instance.track(name_1, data);
            }
        };
    }
    return InternalTracker;
}());
exports.InternalTracker = InternalTracker;
var tracker = new InternalTracker();
exports.tracker = tracker;
function filterEvent(event) {
    var _a, _b;
    if ((_a = event.properties) === null || _a === void 0 ? void 0 : _a.INTERNAL_EVENT_FLAG) {
        console.error('The "INTERNAL_EVENT_FLAG" is meant to be used as a Computed Property Name. Did you mean {[INTERNAL_EVENT_FLAG]: true}?');
    }
    return !!((_b = event.properties) === null || _b === void 0 ? void 0 : _b[INTERNAL_EVENT_FLAG]);
}
function formatEvent(event) {
    var _a;
    var data = event.data, eventProperties = event.properties;
    var properties = __assign({}, eventProperties);
    delete properties[INTERNAL_EVENT_FLAG];
    return {
        name: "".concat(toTitleCase(event.type), "-").concat(toTitleCase(event.name), " [CSSE]"),
        data: __assign(__assign({}, event), { properties: properties, data: {
                project: {
                    name: (_a = data === null || data === void 0 ? void 0 : data.project) === null || _a === void 0 ? void 0 : _a.name,
                    isBootstrapped: (data === null || data === void 0 ? void 0 : data.isBootstrapped) || false,
                    version: (data === null || data === void 0 ? void 0 : data.version) || '',
                },
            } }),
    };
}
function toTitleCase(str) {
    return "".concat(str.slice(0, 1).toUpperCase()).concat(str.slice(1));
}
